import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      gcTime: 1000 * 60 * 60 * 24, // 24h — keep cached data for offline use
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
